import { ChevronDown20, ChevronUp20 } from '@carbon/icons-react';
import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import {
  Collapse as CollpaseAtom,
  Panel,
  PanelHeaderTitle,
} from 'components/atoms/collapse';
import {
  CpBody01Primary,
  CpBody02Primary,
  CpBody03Placeholder,
  CpHeading03Primary,
} from 'components/atoms/customer-portal/typography';
import { useGetBackground } from 'components/organisms/customer-portal/types/utils';
import { CpSectionWrapper } from '../../common';
import { CpFaqVariantWidgetProps } from '../cp-faq-types';

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--cp-spacing-03);
  margin-bottom: var(--cp-spacing-06);

  @media (max-width: 480px) {
    gap: var(--cp-spacing-03);
    margin-bottom: 0;
  }
`;

const Title = styled(CpHeading03Primary)`
  margin-bottom: 0;
`;

const Subtitle = styled(CpBody03Placeholder)`
  margin-bottom: 0;
`;

const FaqQuestion = styled(CpBody02Primary)`
  margin-bottom: 0;
  text-wrap: wrap;
`;

const FaqAnswer = styled(CpBody01Primary)`
  margin-bottom: 0;
  color: var(--cp-text-secondary);
`;

const CpCollapse = styled(CollpaseAtom)`
  .ant-collapse-item {
    border-bottom: 1px solid var(--cp-border-subtle-auto-adjust);
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    display: flex !important;
    flex-direction: column !important;
    background-color: transparent !important;

    .ant-collapse-header {
      height: 80px !important;
      background-color: transparent !important;
      > svg {
        top: 30px;
      }
    }
  }

  .ant-collapse-item .ant-collapse-header:hover {
    background-color: transparent !important;
    border-color: transparent !important;
  }
`;

export const CpFaqAccordion: React.FC<CpFaqVariantWidgetProps> = ({
  data,
  widget,
}) => {
  const { questionsAndAnswers, title, description } = data;
  const background = useGetBackground(widget);

  return (
    <CpSectionWrapper
      className="rl-cp-faq-widget"
      background={background}
      paddingY={
        widget?.widgetDefinition?.styles?.paddingY as number | undefined
      }
    >
      <TitleWrapper>
        <Title autoAdjustColor>{title}</Title>
        <Subtitle autoAdjustColor>{description}</Subtitle>
      </TitleWrapper>

      {questionsAndAnswers.map((qa) => {
        return (
          <CpCollapse
            key="list"
            className="rl-cp-faq-widget"
            ghost
            expandIconPosition="right"
            expandIcon={({ isActive }) => {
              return isActive ? (
                <ChevronUp20 className="cp-svg-auto-adjust-fill" />
              ) : (
                <ChevronDown20 className="cp-svg-auto-adjust-fill" />
              );
            }}
          >
            <Panel
              key="1"
              showArrow
              header={
                <PanelHeaderTitle
                  title={
                    <FaqQuestion autoAdjustColor>{qa.question}</FaqQuestion>
                  }
                />
              }
            >
              <FaqAnswer autoAdjustColor>{qa.answer}</FaqAnswer>
            </Panel>
          </CpCollapse>
        );
      })}
    </CpSectionWrapper>
  );
};
